import InputField from "../../../components/InputField";

export default function PVUtilitiesStep({ data, setField }) {
  const utilities = data.pvUtilities || {};

  const updateUtility = (key, value) => {
    setField("pvUtilities", { ...utilities, [key]: value });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <p style={{
        fontSize: "14px", color: "#4a3f35", margin: "0 0 8px 0",
        fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6,
      }}>
        Introdu indexurile contoarelor la momentul predarii imobilului.
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <InputField
          label="Energie electrica (kWh)"
          value={utilities.energieElectrica || ""}
          onChange={(e) => updateUtility("energieElectrica", e.target.value)}
          placeholder="ex: 12345"
          type="number"
          half
        />
        <InputField
          label="Gaz natural (mc)"
          value={utilities.gaz || ""}
          onChange={(e) => updateUtility("gaz", e.target.value)}
          placeholder="ex: 678"
          type="number"
          half
        />
        <InputField
          label="Apa calda (mc)"
          value={utilities.apaCalda || ""}
          onChange={(e) => updateUtility("apaCalda", e.target.value)}
          placeholder="ex: 45"
          type="number"
          half
        />
        <InputField
          label="Apa rece (mc)"
          value={utilities.apaRece || ""}
          onChange={(e) => updateUtility("apaRece", e.target.value)}
          placeholder="ex: 67"
          type="number"
          half
        />
        <InputField
          label="Incalzire centralizata (Gcal)"
          value={utilities.incalzire || ""}
          onChange={(e) => updateUtility("incalzire", e.target.value)}
          placeholder="ex: 2.5"
          type="number"
          half
        />
      </div>
      <p style={{ fontSize: "11px", color: "#8a7e70", margin: "-8px 0 0 0", fontStyle: "italic" }}>
        Indexurile sunt declarate conform constatarii vizuale la data predarii.
      </p>

      <div>
        <label style={{
          display: "block", fontSize: "13px", fontWeight: 600, color: "#4a3f35",
          marginBottom: "6px", fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em",
        }}>
          Observatii generale
        </label>
        <textarea
          value={data.pvObservatiiGenerale || ""}
          onChange={(e) => setField("pvObservatiiGenerale", e.target.value)}
          placeholder="Observatii generale despre starea imobilului la predare..."
          rows={4}
          style={{
            width: "100%", padding: "12px 16px",
            border: "2px solid #e8e0d4", borderRadius: "10px",
            fontSize: "15px", fontFamily: "'DM Sans', sans-serif",
            backgroundColor: "#fdfbf7", color: "#2d2418",
            outline: "none", boxSizing: "border-box",
            resize: "vertical",
          }}
        />
      </div>
    </div>
  );
}
